export enum TabsEnum {
  GroupTab = 'GroupTab',
  AdminTab = 'AdminTab',
  StoresTab = 'StoresTab',
  SellersTab = 'SellersTab',
}
